import { checksumAddress } from '../../utils/address/getAddress.js';
export async function getAddresses(client) {
    const addresses = await client.request({ method: 'eth_accounts' });
    return addresses.map((address) => checksumAddress(address));
}
//# sourceMappingURL=getAddresses.js.map